// The one place for the app's name and URLs.
// Renaming the app = change APP_DISPLAY_NAME. Switching domains = change the env vars.

export const APP_CODENAME = 'crm';
export const APP_DISPLAY_NAME = 'SimpleFee CRE';
/** Production address. Netlify serves the app here; sign-in links return here. */
export const APP_DOMAIN = 'simplefeecre.com';

const env: Partial<ImportMetaEnv> = (import.meta as { env?: ImportMetaEnv }).env ?? {};

export const config = {
  appName: APP_DISPLAY_NAME,
  /** Where sign-in links return to. Defaults to wherever the app is running. */
  appUrl: env.VITE_APP_URL || (typeof window !== 'undefined' ? window.location.origin : 'http://localhost:5173'),
  supabaseUrl: env.VITE_SUPABASE_URL ?? '',
  supabaseAnonKey: env.VITE_SUPABASE_ANON_KEY ?? '',
  n8nWebhookBase: env.VITE_N8N_WEBHOOK_BASE ?? '',
  timezone: 'America/New_York',
} as const;
